// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1Adg7","content":"style_content__2fksN","icon":"style_icon__gFARz","title":"style_title__1--Km"};